/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useCallback} from 'react';
import isUndefined from 'lodash.isundefined';
import {translate} from '@ion/core/src/locale/locale';
import {BulkSettingFieldValues, GenericObject} from '@ion/core/src/types/entities';
import {FormItem} from '@ion/dls/src/components/forms/FormItem';
import {FormTextField} from '@ion/dls/src/components/forms/FormTextField';
import RadioButton from '@ion/dls/src/components/radio/RadioButton';
import Switch from '@ion/dls/src/components/switch/Switch';
import {DLSTheme} from '@ion/dls/src/types/types';
import {BodyTypography} from '@ion/dls/src/typography/BodyTypography';

export interface SCIAdvanceSensorMenuProps {
  field: GenericObject;
  classes: {
    [key: string]: string;
  };
  noUpdate: boolean;
  handleCustomSwitchChange: Function;
  menu: any;
  value: any;
  bulkSCI?: boolean;
}

const textFieldStyleOverrides = (theme: DLSTheme) => ({
  floatingLabel : {
    color : theme.dls.colors.grey3
  },
  root : {
    '&&' : {
      width     : '66%',
      margin    : '10px 0 10px 130px',
      '&:hover' : {
        backgroundColor : 'transparent'
      }
    }
  },
  underline : {
    backgroundColor : 'transparent'
  },
  inputRoot : {
    '& input' : {
    },
    '&:hover' : {
      backgroundColor : 'transparent'
    }
  }
});
/**
 * View or Edit Advance Sub Menu Sensors related information of an SCI device
 */
export const SCIAdvanceSensorMenu = ({
  field,
  classes,
  noUpdate,
  menu,
  value,
  handleCustomSwitchChange,
  bulkSCI
}: SCIAdvanceSensorMenuProps) => {
  const isFirstVehicleInputAlert: boolean = (
    field.label === translate('admin-devices:view.sciSettings.firstVehicleInputAlert') &&
    !isUndefined(field.vehicleInput1Alert)
  );
  const isVehicleInput1Alert: boolean = ((!isUndefined(field.vehicleInput1Alert)) && field.vehicleInput1Alert);
  const isVehicleInput2Alert: boolean = (
    field.label === translate('admin-devices:view.sciSettings.secondvehicleInputAlert') &&
    !isUndefined(field.vehicleInput2Alert)
  );
  const isMinVehicleInput1: boolean = (
    field.label === translate('admin-devices:view.sciSettings.firstVehicleInputAlert') &&
    !isUndefined(field.minVehicleInput1)
  );
  const isMaxVehicleInput1: boolean = (
    field.label === translate('admin-devices:view.sciSettings.firstVehicleInputAlert') &&
    !isUndefined(field.maxVehicleInput1)
  );

  const getRadioField = (field, value) => {
    return (
      <>
        <RadioButton label
          checked={value}
          value={BulkSettingFieldValues.on}
          onChange={function(e) { handleCustomSwitchChange(e, menu, field.label); }}/>
        <RadioButton label
          checked={value === null}
          value={BulkSettingFieldValues.default}
          onChange={function(e) { handleCustomSwitchChange(e, menu, field.label); }}/>
        <RadioButton label
          checked={value === false}
          value={BulkSettingFieldValues.off}
          onChange={function(e) { handleCustomSwitchChange(e, menu, field.label); }}/>
      </>
    );
  };

  if (isFirstVehicleInputAlert) {
    return (
      <div>
        <FormItem fullWidth>
          <div className={classes.actionsTile}>
            <BodyTypography className={classes.overridesReportTitle}>
              {field.label}
            </BodyTypography>
            {!bulkSCI
              ? <Switch disabled={noUpdate}
                name={field.label}
                onChange={function(e) {
                  handleCustomSwitchChange(e, menu);
                }}
                checked={value}/>
              : getRadioField(field, value)}
          </div>
        </FormItem>
        {isVehicleInput1Alert &&
          <FormItem fullWidth>
            {isMinVehicleInput1 &&
              <div className={classes.actionsTile}>
                <BodyTypography className={classes.overridesReportTitle}>
                  {field.label}
                </BodyTypography>
                <FormTextField label={field.label} disabled={noUpdate} value={field.minVehicleInput1} variant='standard' styleOverrides={textFieldStyleOverrides}/>
              </div>
            }
            {isMaxVehicleInput1 &&
              <div className={classes.actionsTile}>
                <BodyTypography className={classes.overridesReportTitle}>
                  {field.label}
                </BodyTypography>
                <FormTextField label={field.label} disabled={noUpdate} value={field.maxVehicleInput1} variant='standard' styleOverrides={textFieldStyleOverrides}/>
              </div>
            }
          </FormItem>}
      </div>
    );
  }
  if (isVehicleInput2Alert) {
    return (
      <FormItem fullWidth>
        <div className={classes.actionsTile}>
          <BodyTypography className={classes.overridesReportTitle}>
            {field.label}
          </BodyTypography>
          <Switch disabled={noUpdate}
            name={field.label}
            onChange={function(e) {
              handleCustomSwitchChange(e, menu);
            }}
            checked={value}/>
        </div>
      </FormItem>
    );
  }
};

export default SCIAdvanceSensorMenu;
